import { DropdownWithSearch } from "InnoUI/innoinput";
import { measureMent } from "utils/optionData/utils";

const PropertyUnitDropdown = ({
  onChange = () => {},
  defaultValue,
  disabled = true,
  name,
  disabledDropdown,
}) => {
  const options = measureMent.map((data) => ({
    id: data.id,
    label: data.label,
  }));

  const handleDropdownChange = (value) => {
    const selectedOption = options.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.label : "";
    onChange(name, selectedLabel);
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue}
      options={options}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabled={disabled}
      width="68px"
      dropdowType={name}
      disabledDropdown={disabledDropdown}
    />
  );
};

export default PropertyUnitDropdown;
